import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-triangle-left"} maskId="square-filled-radius-0-stroke-1-IconArrowTriangleLeft"><path d="M19.9999 3.69141V20.3094L3.38184 12.0004L19.9999 3.69141Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowTriangleLeft;
